import React, { useState, useEffect } from 'react';

const FeedbackPopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Logic to ensure we don't spam the user
    const lastPrompt = localStorage.getItem('gs_lastFeedbackPrompt');
    const appPromoClicked = localStorage.getItem('appPromoLinkClicked');
    const oneDay = 1 * 24 * 60 * 60 * 1000; // Updated: 24 hours in milliseconds

    const timer = setTimeout(() => {
      const currentTime = Date.now();
      const isDue = !lastPrompt || (currentTime - parseInt(lastPrompt)) > oneDay;
      
      // We only show this if they haven't clicked the app promo and are due for a daily prompt
      if (isDue && !appPromoClicked) {
        setVisible(true);
      }
    }, 8000); // 8 second delay on the Post screen

    return () => clearTimeout(timer);
  }, []);

  const handleAccept = () => {
    setVisible(false);
    // Mark as seen for today
    localStorage.setItem('gs_lastFeedbackPrompt', Date.now().toString());
    
    // Dispatch custom event that ChatBot.js is listening for
    const event = new CustomEvent('openChatToFeedback');
    window.dispatchEvent(event);
  };

  const handleDismiss = () => {
    setVisible(false);
    // Mark as seen today even if dismissed to wait until tomorrow
    localStorage.setItem('gs_lastFeedbackPrompt', Date.now().toString());
  };

  if (!visible) return null;

  return (
    <div className="gs-feedback-toast" style={styles.toast}>
      <button onClick={handleDismiss} style={styles.closeBtn} aria-label="Close feedback prompt">✕</button>
      <div style={styles.content}>
        <p style={styles.title}>Got a quick idea? 💡</p>
        <p style={styles.text}>How can we make this posting screen better for you?</p>
        <button onClick={handleAccept} style={styles.actionBtn}>
          Suggest a Feature
        </button>
      </div>
    </div>
  );
};

const styles = {
  toast: {
    position: 'fixed',
    bottom: '90px', 
    right: '20px',
    width: '280px',
    backgroundColor: '#ffffff',
    border: '1px solid #e1e1e1',
    borderRadius: '12px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
    padding: '16px',
    zIndex: 1050,
    animation: 'slideUpFeedback 0.4s ease-out'
  },
  closeBtn: { 
    position: 'absolute', 
    top: '8px', 
    right: '8px', 
    background: 'none', 
    border: 'none', 
    cursor: 'pointer', 
    color: '#aaaaaa', 
    fontSize: '14px' 
  },
  title: { 
    margin: '0 0 4px 0', 
    fontWeight: 'bold', 
    fontSize: '15px', 
    color: '#111827' 
  },
  text: { 
    margin: '0 0 12px 0', 
    fontSize: '13px', 
    color: '#4B5563', 
    lineHeight: '1.4' 
  },
  actionBtn: { 
    width: '100%', 
    padding: '8px', 
    backgroundColor: '#007bff', 
    color: '#ffffff', 
    border: 'none', 
    borderRadius: '6px', 
    fontWeight: '600', 
    fontSize: '13px',
    cursor: 'pointer' 
  }
};

export default FeedbackPopup;